import $http from '@/api';

const getFields = async (payload, parentContentId) => {
  if (!payload.contentId) {
    // Missing mandatory field: `contentId`.'
    // Use parentContentId or the first entityId as fallback
    payload.contentId = parentContentId || payload.entityIds[0] || null;
  }

  try {
    const response = await $http.post('/api/content/relation/getFields', payload);
    return response.results;
  } catch (e) {
    return [];
  }
};

const getModuleConfigGeneratedFields = async (moduleType, field, payload) => {
  try {
    return await $http.post(`/api/board/module/${moduleType}/get-config-generated-field/${field}`, payload);
  } catch (e) {
    return [];
  }
};

export default {
  getFields,
  getModuleConfigGeneratedFields,
};
